import classNames from 'classnames'
import styles from './LearningPathCardBase.module.scss'

export const LearningPathCardBase = (
  props: React.PropsWithChildren<React.ComponentProps<'div'>>
) => {
  const { children } = props
  return (
    <div {...props} className={classNames(styles.card, props.className)}>
      {children}
    </div>
  )
}
